var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnleeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 32,
    viewBox: "0 0 106 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0256 29.225H28.2886V18.1709C28.2886 15.1119 29.3659 12.5051 31.5207 10.3488C33.6754 8.19408 36.2823 7.1167 39.3427 7.1167C42.4032 7.1167 45.01 8.19408 47.1648 10.3488C49.3195 12.5051 50.3969 15.1119 50.3969 18.1709V29.225H45.6598V18.1709C45.6598 16.4269 45.0438 14.9387 43.8085 13.7051C42.5749 12.4714 41.0852 11.8553 39.3427 11.8553C37.6002 11.8553 36.1106 12.4714 34.8769 13.7051C33.6432 14.9387 33.0256 16.4269 33.0256 18.1709V29.225Z",
    fill: "#FFF2EB",
    stroke: "#FFF2EB",
    strokeWidth: 0.153253,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8752 0.799805V29.2252H52.1382V0.799805H56.8752Z",
    fill: "#FFF2EB",
    stroke: "#FFF2EB",
    strokeWidth: 0.153253,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2046 22.6367C66.4383 23.8704 67.9264 24.488 69.6704 24.488C71.4144 24.488 72.9025 23.8719 74.1362 22.6367L74.1607 22.6122L77.5169 25.9684L77.4924 25.9929C75.3377 28.1492 72.7308 29.225 69.6704 29.225C66.6099 29.225 64.0031 28.1477 61.8483 25.9929C59.6936 23.8382 58.6162 21.2314 58.6162 18.1709C58.6162 15.1104 59.6936 12.5051 61.8483 10.3488C64.0031 8.19408 66.6099 7.1167 69.6704 7.1167C72.7308 7.1167 75.3377 8.19408 77.4924 10.3488C79.6472 12.5051 80.7245 15.1119 80.7245 18.1709C80.7245 18.6981 80.6755 19.2237 80.5759 19.7509H63.551C63.813 20.836 64.3647 21.7984 65.2046 22.6367ZM74.1362 13.7051C72.9025 12.4714 71.4129 11.8553 69.6704 11.8553C67.9279 11.8553 66.4383 12.4714 65.2046 13.7051C64.7939 14.1158 64.4552 14.5526 64.1931 15.0123H75.1492C74.8856 14.5526 74.5484 14.1158 74.1377 13.7051H74.1362Z",
    fill: "#FFF2EB",
    stroke: "#FFF2EB",
    strokeWidth: 0.153253,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0552 22.6367C90.2888 23.8704 91.7769 24.488 93.521 24.488C95.265 24.488 96.7531 23.8719 97.9868 22.6367L98.0113 22.6122L101.368 25.9684L101.343 25.9929C99.1883 28.1492 96.5814 29.225 93.521 29.225C90.4605 29.225 87.8536 28.1477 85.6989 25.9929C83.5442 23.8382 82.4668 21.2314 82.4668 18.1709C82.4668 15.1104 83.5442 12.5051 85.6989 10.3488C87.8536 8.19408 90.4605 7.1167 93.521 7.1167C96.5814 7.1167 99.1883 8.19408 101.343 10.3488C103.498 12.5051 104.575 15.1119 104.575 18.1709C104.575 18.6981 104.526 19.2237 104.426 19.7509H87.4015C87.6636 20.836 88.2153 21.7984 89.0552 22.6367ZM97.9868 13.7051C96.7531 12.4714 95.2635 11.8553 93.521 11.8553C91.7785 11.8553 90.2888 12.4714 89.0552 13.7051C88.6444 14.1158 88.3058 14.5526 88.0437 15.0123H98.9998C98.7362 14.5526 98.399 14.1158 97.9883 13.7051H97.9868Z",
    fill: "#FFF2EB",
    stroke: "#FFF2EB",
    strokeWidth: 0.153253,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7737 30.9448C20.8284 30.9448 26.5473 25.2258 26.5473 18.1711C26.5473 11.1164 20.8284 5.39746 13.7737 5.39746C6.71896 5.39746 1 11.1164 1 18.1711C1 25.2258 6.71896 30.9448 13.7737 30.9448Z",
    fill: "url(#paint0_linear_138_1597)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_138_1597",
    x1: 3.84592,
    y1: 26.2108,
    x2: 23.6999,
    y2: 10.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FEB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FE9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FE7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FE6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FE6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnleeLogo);
export default __webpack_public_path__ + "static/media/OnleeLogo.678abb15644a74b69a6fd674d3538c21.svg";
export { ForwardRef as ReactComponent };